import { createFileRoute } from '@tanstack/react-router';
import { CardSecurityPage } from '../components/pages/CardPage/CardSecurityPage';

export const Route = createFileRoute('/account/cards_/$cardId_/security')({
  component: CardSecurityPage,
});
